import api from './api';
import { pdfOeffnen } from './download';
import type { SalesOrder, SalesOrderItem, Invoice } from './erpTypes';

export const AUFTRAG_STATUS_LABEL: Record<string, string> = {
  draft: 'Entwurf',
  confirmed: 'Bestätigt',
  delivered: 'Geliefert',
  invoiced: 'Berechnet',
  cancelled: 'Storniert',
};

export type AuftragDaten = Partial<Pick<SalesOrder,
  'title' | 'companyId' | 'dealId' | 'quoteId' | 'projectId' | 'leadId' | 'steuerart' | 'discountPercent'
  | 'introText' | 'termsText' | 'deliveryAt' | 'leistungszeitraumVon' | 'leistungszeitraumBis' | 'bestellreferenz'>>;

export type PositionDaten = Partial<Pick<SalesOrderItem,
  'description' | 'unit' | 'quantityHundert' | 'unitPriceCents' | 'discountPercent' | 'taxRate' | 'position'>> & { productId?: string };

const auftragService = {
  async list(filter?: { status?: string; companyId?: string; dealId?: string; projectId?: string }): Promise<SalesOrder[]> {
    const response = await api.get('/auftraege', { params: filter || {} });
    return response.data;
  },
  async get(id: string): Promise<SalesOrder> {
    const response = await api.get(`/auftraege/${id}`);
    return response.data;
  },
  async create(daten: AuftragDaten): Promise<SalesOrder> {
    const response = await api.post('/auftraege', daten);
    return response.data;
  },
  /** Kopiert Positionen, Firma und Vorgang des angenommenen Angebots. */
  async ausAngebot(quoteId: string): Promise<SalesOrder> {
    const response = await api.post(`/auftraege/aus-angebot/${quoteId}`);
    return response.data;
  },
  async update(id: string, daten: AuftragDaten): Promise<SalesOrder> {
    const response = await api.patch(`/auftraege/${id}`, daten);
    return response.data;
  },
  async setStatus(id: string, status: 'confirmed' | 'delivered' | 'cancelled'): Promise<SalesOrder> {
    const response = await api.post(`/auftraege/${id}/status`, { status });
    return response.data;
  },
  /** Erzeugt den Rechnungsentwurf ueber die noch unberechneten Mengen. */
  async rechnungErzeugen(id: string, teil?: boolean): Promise<Invoice> {
    const response = await api.post(`/auftraege/${id}/rechnung`, { teil });
    return response.data;
  },
  async addItem(id: string, daten: PositionDaten): Promise<SalesOrder> {
    const response = await api.post(`/auftraege/${id}/positionen`, daten);
    return response.data;
  },
  async updateItem(itemId: string, daten: PositionDaten): Promise<SalesOrder> {
    const response = await api.patch(`/auftraege/positionen/${itemId}`, daten);
    return response.data;
  },
  async removeItem(itemId: string): Promise<SalesOrder> {
    const response = await api.delete(`/auftraege/positionen/${itemId}`);
    return response.data;
  },
  pdfOeffnen: (id: string) => pdfOeffnen(`/auftraege/${id}/pdf`),
};

export default auftragService;
